import axios from "../axios";

/**
 * 保存
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const save = (data) => {
  return axios({
    url: "/mZlbak/save",
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    method: 'post',
    data
  })
}

/**
 * 列表查询
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const findPage = (data) => {
  return axios({
    url: '/mZlbak/list',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    method: 'post',
    data
  })
}

export const del = (data) => {
  return axios({
    url: '/mZlbak/delete',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/zlbak.js